import Vue from "vue";
import Router from "vue-router";
import Introduction from "@/pages/introduction";
import Team from "@/pages/team";
import Fund from "@/pages/fund";
import Active from "@/pages/active";
import Funda from "@/pages/fund-1";
import Fundb from "@/pages/fund-2";
import Main from "@/pages/main";
import About from "@/pages/about.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: Main
    },
    {
      path: "/introduction/:id?",
      name: "introduction",
      component: Introduction
    },
    {
      path: "/team",
      name: "team",
      component: Team
    },
    {
      path: "/fund/:id?",
      name: "fund",
      component: Fund
    },
    {
      path: "/active/:id?",
      name: "active",
      component: Active
    },
    {
      path: "/fund-1",
      name: "fund-1",
      component: Funda
    },
    {
      path: "/fund-2",
      name: "fund-2",
      component: Fundb
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/main",
      name: "main",
      component: Main
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js